<template>
  <!-- https://github.com/uscreen/vue-video-player#spa -->
  <video-player
      v-if="this.playerisoption"
      class="vjs-custom-skin hide-play-button"
      ref="videoPlayer"
      :options="playerOptions"
      :playsinline="true"
      @play="onPlayerPlay($event)"
      @pause="onPlayerPause($event)"
      @ended="onPlayerEnded($event)"
      @loadeddata="onPlayerLoadeddata($event)"
      @waiting="onPlayerWaiting($event)"
      @playing="onPlayerPlaying($event)"
      @timeupdate="onPlayerTimeupdate($event)"
      @canplay="onPlayerCanplay($event)"
      @canplaythrough="onPlayerCanplaythrough($event)"
      @ready="playerReadied"
      @statechanged="playerStateChanged($event)">
  </video-player>
</template>

<script>
import Vue from 'vue'

Vue.use(window.VueVideoPlayer)
export default {
  data() {
    return {
      initialized: false,
      currentTech: '',
      currentTimes: 0,
      durationTimes: 0,
      remainingTimes: 0,
      resultPercent: 0,
      indexTimes: 0,
      preValue: {newVal: 0, oldVal: 0, cal: 0},
      isIndexTime: false,
      isEnded: false,
      changeText: {},
      listState: [],
      playerOptions: {
        height: '360',
        autoplay: true,
        muted: true,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        // sources: undefined,
        sources: [{
          type: "video/mp4",
          // mp4
          // src: "http://localhost:8080/video/20211019/202110190855111.mp4",
          src: this.playerisoption,
          // webm
          // src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
        }],
        poster: "", // 썸네일
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
          remainigTimeDisplay: false,
          fullscreenToggle: false
        }
      }
    }
  },
  props: ['playerisoption'], // mp4 경로
  created() {},
  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  watch: {},
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    }
  },
  methods: {
    onPlayerPlay(player) {},
    onPlayerPause(player) {},
    onPlayerEnded(player) {
      this.initialized = false;
      player.play();
    },
    onPlayerLoadeddata(player) {},
    onPlayerWaiting(player) {},
    onPlayerPlaying(player) {},
    onPlayerTimeupdate(player) {},
    onPlayerCanplay(player) {},
    onPlayerCanplaythrough(player) {},
    // or listen state event
    playerStateChanged(playerCurrentState) {},
    // player is ready
    playerReadied(player) {
      // console.log("5YZ0lB0XJCaHuPNCfjLQgotwbPAsuX this.playerisoption = ",this.playerisoption)
      // console.log("5YZ0lB0XJCaHuPNCfjLQgotwbPAsuX this.$attrs = ",this.$attrs)

      if (!this.initialized) {
        this.initialized = true;
        // player.src(this.playerisoption);
        this.$refs.videoPlayer.player.controlBar.hide();
        this.$emit('playerReadied', player);
        player.currentTime(1);
      }
    },
    fnOnLoadTime: function (_curTime, _player, isPause) {
      let _current = (_curTime == 1) ? _player.currentTime() : Math.abs(_curTime - _player.currentTime());
      let _percent = this.fnOnLoadPercent(_current, _player.duration());
      this.changeText = {
        currentTime: this.fnOnLoadTimeUpdate(_player.currentTime()),
        durationTime: this.fnOnLoadTimeUpdate(_player.duration()),
        remainTime: this.fnOnLoadTimeUpdate(_player.remainingTime()),
        percent: _percent

      };
      // this.$attrs.playerisoption.playerListener.detail = this.changeText;
    },
    fnOnLoadPercent: function (_curTime, _durTime) {
      return parseInt(((_curTime / _durTime) * 100))
    },
    fnOnLoadTimeUpdate: function (_value) {
      return parseFloat(_value / 60).toFixed(2);
    },
    fnOnLoadPause: function () {},
  }
}
</script>
<style>
/* 희안하게 못생긴 플레이 버튼 감추기 */
.hide-play-button .vjs-big-play-button { display: none !important; }
</style>
